import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateChatProviderMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.chatProviders.create.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async () => {
            utils.chatProviders.findAll.invalidate();
            toast.success("Model created successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useUpdateChatProviderMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.chatProviders.update.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async (data) => {
            utils.chatProviders.findAll.invalidate();
            utils.chatProviders.findById.invalidate({ id: data.id });
            utils.chatProviders.findByProvider.invalidate({ provider: data.provider });
            toast.success("Model updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useSetEnabledChatProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.chatProviders.setEnabled.useMutation({
        onSuccess: async (data) => {
            utils.chatProviders.findAll.invalidate();
            utils.chatProviders.findEnabled.invalidate();
            toast.success(`Model ${data.enabled ? "enabled" : "disabled"} successfully`);
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};

export const useDeleteChatProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.chatProviders.delete.useMutation({
        onSuccess: async () => {
            utils.chatProviders.findAll.invalidate();
            toast.success("Model deleted successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
